import request from "../config/request";
import store from "../redux/store";
import api_domain_config from '../config/config';
import Cookies from "js-cookie";
import qs from 'qs';

//api http://192.168.1.25:3000/project/29/interface/api/7562
let apiUrl = api_domain_config.API_URL;


/**
 * 获取图形验证码
 * @param {object} 请求参数
 */
export async function requestGetCaptcha() {
    return request(apiUrl + "v1/captcha/check", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

/**
 * 请求用户注册
 * @param {object} 请求参数
 */
export async function requestSignUp(params) {
    return request(apiUrl + "v3/account/register", {
        method: "POST",
        redirect: "follow",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
    })
};


/**
 * 发送短信验证码
 * @param {object} 请求参数
 * http://192.168.1.25:3000/project/29/interface/api/4160
 */
export async function requestSmsCode(params) {
    return request(apiUrl + "v1/captcha/send", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
    })
};

// 校验短信验证码
export async function checkSmsCode(params) {
    return request(apiUrl + "v1/captcha/check", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
    })
};

/**
 * 请求用户登录
 * @param {object} 请求参数
 */
export async function requestLogin(params) {
    return request(apiUrl + "v1/oauth/token", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
    })
};

// 用户修改密码
export async function resetPassword(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + "v1/account/captcha/reset-password", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify(params)
    })
};

//获取用户账号信息
export async function getUserInfo() {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + "v1/account/info", {
        method: "GET",
        headers: {
            authorization: `Bearer ${authorization}`,
        },
    })
};

//修改用户信息
export async function updateUserInfo(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + "v1/account/profile", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify(params)
    })
};


//获取产品列表
export async function queryProductList(site_id) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + `v1/products?site_id=${site_id}`, {
        method: "GET",
        headers: {
            authorization: `Bearer ${authorization}`,
        },
    })
};


//获取产品详情
export async function getProductDetailById(pid) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + `v1/products/${pid}`, {
        method: "GET",
        headers: {
            authorization: `Bearer ${authorization}`,
        },
    })
};

//用户找回密码
export async function findPassword(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + `v2/account/find-password`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify(params)
    })
};

//取消自动续费
export async function cancelSubscription(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + 'v1/order/cancel-sub', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify(params)
    })
};

//获取订单信息
export async function requestOrderList(type, params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + `v1/orders/${type}?page=${params.page}&limit=${params.limit}&site_id=${params.site_id}`, {
        method: "GET",
        headers: {
            authorization: `Bearer ${authorization}`,
        },
    })
};

//获取微信公众号绑定二维码
export async function requestWechatBindingQrcode() {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + `v1/auth/wechat-bind-qrcode`, {
        method: "GET",
        headers: {
            authorization: `Bearer ${authorization}`,
        },
    })
};

//轮询当前用户登录状态
export async function roundRobinAccountStatus(params) {
    return request(apiUrl + 'v1/auth/wechat-sync-login', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
    })
};

//通过站点获取产品列表http://192.168.1.25:3000/project/29/interface/api/10199
export async function getProductListBySiteId(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + `v2/product/list?site_id=${params.site_id}`, {
        method: "GET",
        headers: {
            authorization: `Bearer ${authorization}`,
        },
    })
};

//邮箱绑定http://192.168.1.25:3000/project/29/interface/api/10210
export async function requestBindAccount(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + 'v1/account/bind-user', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization: `Bearer ${authorization}`,
        },
        body: qs.stringify(params)
    })
};

/**
 * 获取用户绑定的第三方列表(用于判断当前用户是否已经绑定微信)
 * http://192.168.1.25:3000/project/29/interface/api/10070
 */
export async function getAuthComnonThirdList() {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + `v1/auth/common/third`, {
        method: "GET",
        headers: {
            authorization: `Bearer ${authorization}`,
        },
    })
}

/**
 * 解除用户绑定 http://192.168.1.25:3000/project/29/interface/api/7562
 * @param {*} params 
 * @returns 
 */
export async function unbindUser(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + 'v1/auth/common/unbind-user', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify(params)
    })
};

/**
 * 解除账号绑定(手机号/邮箱)
 * @param {*} params 
 * @returns 
 */
export async function accountUnBind(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + 'v1/account/unbind', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify(params)
    })
};

//用户上传头像http://192.168.1.25:3000/project/29/interface/api/3914
export async function imageUpload(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + 'v1/function/upload', {
        method: "POST",
        headers: {
            // 'Content-Type': 'multipart/form-data',
            authorization: `Bearer ${authorization}`,
        },
        body: params
    })
};


//登录态获取
export async function checkStid(params) {
    let authorization = store.getState().account.authorization;
    return request(apiUrl + 'v1/check/stid', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify(params)
    })
};